import { css } from '@emotion/css'
import { fontSize, fontWeight, spacing, colors } from '@offerzen/pinata-shame'

const styles = {
  wrapper: css({
    marginBottom: spacing.default,
  }),

  trigger: css({
    marginLeft: spacing.small,
  }),

  radioGroup: css({
    legend: {
      width: '100%',
      marginBottom: spacing.medium,
      fontWeight: fontWeight.medium,
      fontSize: fontSize.medium,
      color: colors.blackPearl,
    },

    '> div': {
      flexDirection: 'column',
    },
  }),

  startDate: css({
    width: '100%',
    marginBottom: spacing.large,
    input: {
      height: '100%',
    },
  }),

  footer: css({
    marginTop: spacing.large,
  }),
}

export default styles
